import { Type } from '@angular/core';

import { getDefaultBaseOptions, BaseSpecOptions } from '../base/options';
import { merge } from '../internals/merge';
import { OptionalsRequired } from '../types';

/**
 * @publicApi
 */
export interface SpecOptions<C> extends BaseSpecOptions {
  component: Type<C>;
  shallow?: boolean;
  componentProviders?: any[];
  componentViewProviders?: any[];
  detectChanges?: boolean;
  declareComponent?: boolean;
  componentMocks?: Type<any>[];
  componentViewProvidersMocks?: Type<any>[];
}

const defaultSpecOptions: OptionalsRequired<SpecOptions<any>> = {
  ...getDefaultBaseOptions(),
  shallow: false,
  declareComponent: true,
  detectChanges: true,
  componentProviders: [],
  componentViewProviders: [],
  componentMocks: [],
  componentViewProvidersMocks: []
};

/**
 * @internal
 */
export function getSpecDefaultOptions<C>(overrides?: SpecOptions<C>): Required<SpecOptions<C>> {
  return merge(defaultSpecOptions, overrides);
}
